import React from 'react';
import { withRouter } from 'react-router-dom';
import Suspense from '../../Common/components/Suspense-component';
import PatientDetails from '../component-details-patient';
import { getSinglePatient } from '../epics-patients';

class PatientDetailsContainer extends React.Component {
    generatePatientDetails = () => {
        const url = this.props.location.pathname;
        let patientId = url.split('/').pop();

        return getSinglePatient(patientId);
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    patientDetails: this.generatePatientDetails
                }}
            >
                <PatientDetails />
            </Suspense>
        );
    }
}

export default withRouter(PatientDetailsContainer);



// WEBPACK FOOTER //
// ./src/customModules/Patients/containers/container-details-patient.js